module.exports = __webpack_public_path__ + "img/67_5.e85e6104.png";